import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { PurchaseItem } from "@/models/purchase-item.model"

export const usePurchaseItemStore = defineStore("purchaseItemStore", () => {
  const purchaseItems: Ref<PurchaseItem[]> = ref([])

  return {
    purchaseItems
  }
})
